import { isStaticHosted, getS3Domain } from 'utils/DOM';
export const sendMessage = msg => {
  const iFrame = document.getElementById('sender').contentWindow;
  const targetOrigin = isStaticHosted()
    ? getS3Domain()
    : window.location.origin;
  setTimeout(() => iFrame.postMessage(msg, targetOrigin), 0);
};



// WEBPACK FOOTER //
// ./src/utils/postMessage.js